export const Roles = {
    Admin: 'admin',
    Supplier: 'supplier',
    Seller: 'seller',
    Agent: 'agent',
    Member: 'member',
    Customer: 'customer',
    Staff: 'staff'
}